import { useState } from "react";
import { Dayjs } from "dayjs";
import { useMe } from "@/data/user.ts";
import { useModalState } from "@/contexts/modal/Context.tsx";
import { AnimatePresence } from "framer-motion";
import { feedbackOptions } from "@/data/static/agenda";
import { FeedbackProps, ITypes } from "@/types";
import FirstPage from "@/components/agenda/desktop/feedback/FirstPage.tsx";
import SecondPage from "@/components/agenda/desktop/feedback/SecondPage.tsx";
import FourthPage from "@/components/agenda/desktop/feedback/FourthPage.tsx";

interface AgendaEventFeedbackModalData {
  date: Dayjs;
  title: string;
  id_user: string;
  id_evento: number;
  tutor_nome: string;
  modifiedType: ITypes;
}

export default function AgendaEventFeedbackModal() {
  const { me } = useMe();
  const { data } = useModalState();

  const {
    title,
    date,
    tutor_nome: tutorName,
    id_evento: eventId,
    modifiedType,
  } = data as AgendaEventFeedbackModalData;

  const [active, setActiveTab] = useState(0);
  const [comment, setComment] = useState<string | undefined>();
  const [feedback, setFeedback] = useState<FeedbackProps>({
    id_user: me?.item.user.id || 0,
    id_evento: eventId,
    rating: {
      tutor: 0,
      topicAndOrganization: 0,
    },
  });

  const nextPage = (stars: { tutor: number; topicAndOrganization: number }) => {
    setFeedback((r) => {
      r.rating = stars;
      return r;
    });

    if (stars.tutor < 4 && stars.topicAndOrganization < 4) {
      setActiveTab(2);
    } else if (
      stars.tutor < 4 ||
      stars.topicAndOrganization < 4 ||
      (stars.tutor === 5 && stars.topicAndOrganization === 5)
    ) {
      setActiveTab(1);
    } else {
      setActiveTab(1);
    }
  };

  const feedbackAreas: Array<keyof typeof feedbackOptions> = [];

  if (feedback.rating.tutor <= 4) {
    feedbackAreas.push("Tutor");
  }

  if (feedback.rating.topicAndOrganization <= 4) {
    feedbackAreas.push("Topic and organization");
  }

  return (
    <AnimatePresence>
      {active === 0 && (
        <FirstPage
          date={date}
          title={title}
          tutor={tutorName}
          nextPage={nextPage}
        />
      )}

      {active === 1 && (
        <SecondPage
          comment={comment}
          feedback={feedback}
          nextPage={() => setActiveTab(2)}
          setComment={setComment}
        />
      )}

      {active === 2 && (
        <FourthPage
          type={modifiedType}
          comment={comment}
          feedback={feedback}
          feedbackAreas={feedbackAreas}
        />
      )}
    </AnimatePresence>
  );
}
